import { useEffect, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";

// Canvi d'idioma compartit pels dos selects
const useCanviIdioma = (lang) => {
    const [canviant, setCanviant] = useState(null);

    const canviar = (codigo) => {
        if (codigo === lang || canviant) return;
        setCanviant(codigo);

        const token = document.getElementById("meta_token").getAttribute("content");

        axios.post("/cambiaidioma", { lang: codigo }, {
            headers: { "content-type": "text/json", "X-CSRF-TOKEN": token },
        })
            .then(() => window.location.reload())
            .catch(() => setCanviant(null));
    };

    return { canviant, canviar };
};

// Menú de mòbil (pantalla completa)
const IdiomasMovil = ({ idiomas, lang }) => {

    const { canviant, canviar } = useCanviIdioma(lang);

    if (!idiomas || idiomas.length < 2) return null;

    return (
        <div className="bhm-idiomas" role="group" aria-label="Idioma">
            {idiomas.map((idioma) => {
                const actiu = idioma.codigo === lang;
                return (
                    <button
                        type="button"
                        key={idioma.codigo}
                        className={"bhm-idiomas__item" + (actiu ? " bhm-idiomas__item--actiu" : "") + (canviant === idioma.codigo ? " bhm-idiomas__item--canviant" : "")}
                        aria-pressed={actiu}
                        title={idioma.nombre}
                        lang={idioma.codigo}
                        onClick={() => canviar(idioma.codigo)}
                    >
                        {idioma.codigo.toUpperCase()}
                    </button>
                );
            })}
        </div>
    );
};

// Menú d'escriptori: desplegable amb el codi de l'idioma
export const IdiomasEscritorio = ({ idiomas, lang }) => {

    const { i18n } = useTranslation();
    const { canviant, canviar } = useCanviIdioma(lang);
    const actual = (lang || "es").toString().toLowerCase();

    useEffect(() => {
        i18n.changeLanguage(actual);
    }, [actual]);

    if (!idiomas || idiomas.length < 2) return null;

    return (
        <NavDropdown
            className="navegacio bhm-idioma"
            title={<span aria-label="Idioma">{actual.toUpperCase()}</span>}
            id="bhm-idioma"
            align="end"
        >
            {idiomas.map((idioma) => (
                <NavDropdown.Item
                    as="button"
                    type="button"
                    key={idioma.codigo}
                    active={idioma.codigo === actual}
                    title={idioma.nombre}
                    lang={idioma.codigo}
                    disabled={canviant !== null && canviant !== idioma.codigo}
                    onClick={() => canviar(idioma.codigo)}
                >
                    {idioma.codigo.toUpperCase()}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
};

export default IdiomasMovil;
